import React, {useEffect, useState} from "react";
import {Modal, Button, Spinner} from "react-bootstrap";
import {instanceMob} from "../../../../utils/utils";

const PlanDetailModal = ({show, onClose, plan}) => {
    const [planDetail, setPlanDetail] = useState();
    const [loading, setLoading] = useState(true);

    const cycleOptions = [
        {id: 1, name: "Diario", value: 10},
        {id: 2, name: "Mensual", value: 20},
        {id: 3, name: "Anual", value: 30},
    ];

    const getPlanDetail = (id) => {
        setLoading(true);
        return instanceMob
            .get(`admin/plan/${id}`)
            .then((res) => res.data)
            .then((data) => {
                setPlanDetail(data);
                return data;
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (plan?.id) {
            getPlanDetail(plan.id);
        }
    }, [plan]);

    if (!plan) return null;

    const renewalCycle =
        cycleOptions.find((opt) => opt.value === Number(plan?.renewal_cycle_time))
            ?.name || "—";

    const renderValue = (value, formatter) => {
        if (loading) return <span className="placeholder w-50">—</span>;
        return formatter ? formatter(value) : value || "—";
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            scrollable
            size="sm"
            className="plan-detail-modal justify-content-center"
        >
            <Modal.Header>
                <Modal.Title className="plan-detail-modal-title w-100 text-center">
                    Resumen del plan
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column align-items-center gap-2 px-5">
                <div
                    className="plan-detail-modal-info-list d-flex flex-column align-items-center justify-content-center w-100 border">

                    <div className="plan-detail-modal-info-item d-flex flex-column gap-1 p-1 w-100 text-center">
                        <span className="plan-detail-modal-labels fw-bold">Nombre del plan</span>
                        <span className="plan-detail-modal-labels">
                            {renderValue(plan?.name)}
                        </span>
                    </div>

                    <div className="plan-detail-modal-info-item d-flex flex-column gap-1 p-1 w-100 text-center">
                        <span className="plan-detail-modal-labels fw-bold">
                            Ciclo de renovación <i className="bi bi-arrow-clockwise"></i>
                        </span>
                        <span className="plan-detail-modal-labels">
                            {renderValue(renewalCycle)}
                        </span>
                    </div>

                    <div className="plan-detail-modal-info-item d-flex flex-column gap-1 p-1 w-100 text-center">
                        <span className="plan-detail-modal-labels fw-bold">
                            Frecuencia de renovación <i className="bi bi-arrow-clockwise"></i>
                        </span>
                        <span className="plan-detail-modal-labels">
                            {renderValue(plan?.renewal_cycle_value)}
                        </span>
                    </div>

                    <div className="plan-detail-modal-info-item d-flex flex-column gap-1 p-1 w-100 text-center">
                        <span className="plan-detail-modal-labels fw-bold">
                            Congelaciones <i className="bi bi-snow"></i>
                        </span>
                        <span className="plan-detail-modal-labels">
                            {renderValue(plan?.max_freeze_times)}
                        </span>
                    </div>

                    <div className="plan-detail-modal-info-item d-flex flex-column gap-1 p-1 w-100 text-center">
                        <span className="plan-detail-modal-labels fw-bold">Valor del plan</span>
                        <span className="plan-detail-modal-labels">
                            {renderValue(plan?.price, (val) => {
                                return `$ ${new Intl.NumberFormat('es-CO').format(val)}`;
                            })}
                        </span>
                    </div>

                    {planDetail?.full_services_access ? (
                        <div
                            className="plan-detail-modal-info-item d-flex flex-row justify-content-around align-items-center gap-1 p-2 w-100 text-center"
                        >
                            <span className="plan-detail-modal-labels fw-bold">Accesos libres</span>

                            <div className="d-flex flex-column gap-2 align-items-center">
                                <span className="plan-detail-modal-labels fw-bold">Ilimitados</span>
                                <span
                                    className={`plan-detail-modal-labels plan-detail-modal-chip w-100 ${
                                        loading
                                            ? "loading"
                                            : planDetail?.total_spots_per_service === -1
                                                ? "success"
                                                : "error"
                                    }`}
                                >
                                {loading
                                    ? "—"
                                    : planDetail?.total_spots_per_service === -1
                                        ? "Sí"
                                        : "No"}
                                </span>
                            </div>

                            <div className="d-flex flex-column gap-2 align-items-center">
                                <span className="plan-detail-modal-labels fw-bold">Accesos</span>
                                <span
                                    className={`plan-detail-modal-labels ${
                                        loading && "loading"
                                    }`}
                                >
                                {loading
                                    ? "—"
                                    : planDetail?.total_spots_per_service === -1
                                        ? "Ilimitados"
                                        : planDetail?.total_spots_per_service || 0}
                                </span>
                            </div>
                        </div>
                    ) : (
                        planDetail?.services?.map((service) => (
                            <div
                                key={service.service_id}
                                className="plan-detail-modal-info-item d-flex flex-row justify-content-around align-items-center gap-1 p-2 w-100 text-center"
                            >
                                <span className="plan-detail-modal-labels fw-bold plan-detail-col-name">
                                    {service.service_name}
                                </span>
                                <div className="plan-detail-col d-flex flex-column gap-2 align-items-center">
                                    <span className="plan-detail-modal-labels fw-bold">Ilimitados</span>
                                    <span
                                        className={`plan-detail-modal-labels plan-detail-modal-chip w-100 ${
                                            loading
                                                ? "loading"
                                                : service.quota === -1
                                                    ? "success"
                                                    : "error"
                                        }`}
                                    >
                                        {loading ? "—" : service.quota === -1 ? "Sí" : "No"}
                                    </span>
                                </div>

                                <div className="plan-detail-col d-flex flex-column gap-2 align-items-center">
                                    <span className="plan-detail-modal-labels fw-bold">Accesos</span>
                                    <span
                                        className={`plan-detail-modal-labels ${
                                            loading && "loading"
                                        }`}
                                    >
                                        {loading ? "—" : service.quota === -1 ? "Ilimitados" : service.quota}
                                    </span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <Button
                    variant="primary"
                    className="plan-detail-modal-button"
                    onClick={onClose}
                    disabled={loading}
                >
                    {loading ? (
                        <Spinner animation="border" size="sm"/>
                    ) : (
                        "Confirmar"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PlanDetailModal;
